import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-83" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-84" data-mp="1ge0fontl8wdl">
        <div className="text-center" data-id="element-85" data-mp="1gauuhjo2yen5">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-86" data-mp="2e0pn5d72816u">
            Hai ancora dubbi?
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-87" data-mp="2924mxdrt5hie">
            Domande <span className="italic text-grape" data-id="element-88" data-mp="1z3fgqi99xlhz">Frequenti</span>
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-89" data-mp="sn3h0cqszvka">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-90" data-mp="nn8lfvw32hsw" data-mpi={index}>
                <h3 data-id="element-91" data-mp="pizd5qpiisco">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal/40" data-id="element-92" data-mp="pih7k3gyn1s3">
                    <span className="text-sm font-bold text-navy" data-id="element-93" data-mp="6qww4e8yla1w">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-teal transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-94" data-mp="bi6jf871c1am" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-95" data-mp="3jxgfnzo8ucah">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-96" data-mp="3nzk19h4mmx9h">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-navy/60" data-id="element-97" data-mp="1krktse9scp1e">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}